// extracted by mini-css-extract-plugin
export default {"buyreward-close-icon":"BuyReward_buyreward-close-icon_uXA1b","buyreward-tips-page":"BuyReward_buyreward-tips-page_ecR20","buyreward-wrapper":"BuyReward_buyreward-wrapper_utc82"};